module.exports = __webpack_public_path__ + "img/5pica.5ab3d862.png";